import { getSearch, requestCreate, requestDelete, requestUpdate } from "../api"
import {
    ADD_IN_LIST,
    REMOVE_IN_LIST,
    RESET_SEARCH_PARAMS,
    RESET_STATE, SET_LIST, SET_LOADING, UPDATE_IN_LIST
} from "../constant-types"
import { defaultAddInListMutation, defaultRemoveInListMutation, defaultSetListMutation, defaultUpdateInListMutation } from "../default-method"
import { getField, updateField } from 'vuex-map-fields'

const getDefaultState = () => {
    return {
        list : null,
        search_params: getDefaultSearchParamsState()
    }
}

const getDefaultSearchParamsState = () => {
    return {
        filter_search_text : '',
        loading : false,
        filter_sort : [{
            column : 'name',
            sort : 'asc',
            icon : ['fas', 'angle-up']
        }],
        filter_page : 1,
        filter_limit : 20
    }
}

const createForm = (rootState) => ({
    ...rootState.supplierForm.rows[0],
    contacts : rootState.contactForm.rows,
    addresses : rootState.addressForm.rows,
})

export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        [RESET_SEARCH_PARAMS](state) {
            state.search_params = getDefaultSearchParamsState()
        },
        [SET_LOADING](state, boolean) {
            state.search_params.loading = boolean
        },
        ...defaultSetListMutation,
        ...defaultAddInListMutation,
        ...defaultRemoveInListMutation,
        ...defaultUpdateInListMutation,
        updateField

    },
    // can async
    actions: {
        loadList({commit, state, getters}, payload = { resetPage : false}) {
            if (payload.resetPage) {
                commit('updateField', { path : 'search_params.filter_page', value : 1})
            }
            commit(SET_LOADING, true)
            return getSearch(
                {words: _.split(state.search_params.filter_search_text, ' '), fields : ['name']},
                [],
                [],
                state.search_params.filter_sort,
                state.search_params.filter_page,
                state.search_params.filter_limit,
                ['companyTax', 'addresses', 'contacts.contactClass'],
                [],
                'supplier',
                (response) => commit(SET_LIST, response),
                ()=>{},
                ()=>{commit(SET_LOADING, false)}
            )
        },
        requestCreateSupplier({commit, rootState}) {
            return requestCreate('supplier', createForm(rootState), commit, ADD_IN_LIST)
        },
        requestUpdateSupplier({commit, rootState}) {
            return requestUpdate(`supplier/${rootState.supplierForm.rows[0].id}`, createForm(rootState), commit, UPDATE_IN_LIST)
        },
        requestDeleteSupplier({commit, rootState}, supplier) {
            return requestDelete(`supplier/${supplier.id}`, {}, commit, supplier.name, REMOVE_IN_LIST)
        },
        resetForm({commit}) {
            commit('supplierForm/RESET_FORM', null, { root: true})
            commit('contactForm/RESET_FORM', null, { root: true})
            commit('addressForm/RESET_FORM', null, { root: true})
        },
        setForm({commit, state}, supplier) {
            commit('supplierForm/SET_FORM', _.omit(supplier, ['contacts', 'addresses']), { root: true})
            commit('contactForm/SET_FORMS', supplier.contacts, { root: true})
            commit('addressForm/SET_FORMS', supplier.addresses, { root: true})
        }
    },
    // call variable with custom display
    getters: {
        getField
    },
})
